import { Modal, Paper } from '@mui/material';
import { RefObject, useEffect, useState } from 'react';
import { DiiaQRCode, TimerRefHandle } from '../SignatureVerification/DiiaQRCode';
import { SelectVerificationMethod } from './SelectVerificationMethod';
import { VerificationChoice } from './types';
import { styles } from './styles';

interface IVerificationModalProps {
  isModalOpen: boolean;
  handleDiiaVerification: () => void;
  handleVideoVerification: () => void;
  deepLink?: string;
  onClose: () => void;
  timerRef: RefObject<TimerRefHandle>;
  isVideoVerification: boolean;
  clientType?: string;
}

const VerificationModal = ({
  isModalOpen,
  handleDiiaVerification,
  handleVideoVerification,
  onClose,
  deepLink,
  timerRef,
  isVideoVerification,
  clientType,
}: IVerificationModalProps) => {
  const [selectedSignature, setSelectedSignature] = useState<VerificationChoice | null>(null);
  const [step, setStep] = useState(0);

  useEffect(() => {
    setStep(0);
    setSelectedSignature(null);
  }, [isModalOpen]);

  const handleDiiaSelect = () => {
    setSelectedSignature(VerificationChoice.DIIA);
    handleDiiaVerification();
    setStep(1);
  };
  const handleVideoSelect = () => {
    setSelectedSignature(VerificationChoice.VIDEO);
    handleVideoVerification();
  };

  const handleClose = () => {
    onClose();
    setStep(0);
    setSelectedSignature(null);
  };

  const getCurrentStep = (step: number) => {
    switch (step) {
      case 0:
        return (
          <SelectVerificationMethod
            handleDiiaVerification={handleDiiaSelect}
            handleVideoVerification={handleVideoSelect}
            isDiiaVerification
            isVideoVerification={isVideoVerification}
            clientType={clientType}
          />
        );
      case 1:
        return selectedSignature === VerificationChoice.DIIA ? (
          <DiiaQRCode
            deepLink={deepLink || ''}
            timerRef={timerRef}
            qrCodeTimer={180}
            inRow
            diiaTitle={'Поділитися документами в Дії'}
            instructionText={
              'Дотримуйтесь подальших інструкцій в застосунку Дія. Потрібно надати копії РНОКПП та наявного паспорта (ID-картки або закордонного)'
            }
          />
        ) : null;
      default:
        break;
    }
  };

  return (
    <Modal open={isModalOpen} onClose={handleClose}>
      <Paper sx={styles.verificationModal}>{getCurrentStep(step)}</Paper>
    </Modal>
  );
};

export default VerificationModal;
